
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { isGoodsValid } from '@/api/industryMall'
import { decimalPrecision, handleFill } from '@/utils/util'
import customRadio from '@/views/industryMall/goods/components/customRadio.vue'
import priceFun from '@/views/industryMall/shop/template/priceFun.vue'
import { batchHandleGoods } from '@/api/ccx'

@Component({
  components: {
    priceFun,
    customRadio
  }
})
export default class editGoodsCards extends Vue {
  decimalPrecision = decimalPrecision
  handleFill = handleFill

  @Getter companyId!: string
  @Prop({ default: () => {} }) data!: any
  showPopup = false
  price = 0
  scribingPrice = 0
  initStockQuantity: number | string | null = null
  stockQuantity: number | null = null
  soldQuantity = 0
  limitPerPersonDaily: number | string | null = null
  isDailyRefresh = 1
  sftpUrl = ''

  @Watch('data')
  dataChange(val) {
    console.log('dataChange**************', val)
  }

  @Watch('initStockQuantity')
  onInitStockQuantityChange(val: any) {
    if (val === '' || val === null || val === undefined) {
      return
    }
    const n = Number(val)
    if (!Number.isFinite(n)) return
    this.stockQuantity = Math.max(0, n - this.soldQuantity)
  }

  get showStockTip() {
    return this.initStockQuantity !== '' && this.initStockQuantity != null
  }

   get sellUnit() {
    const { sellUnit, sellUnitWay } = this.data;
    // 如果没有销售单位规格，直接返回单位名称
    if (!sellUnit) {
      return sellUnitWay || ''
    }
    
    // 如果是千克单位且数量小于1，转换为克显示
    const isKilogram = sellUnitWay?.toLowerCase() === 'kg'
    if (sellUnit < 1 && isKilogram) {
      return `${Math.round(sellUnit * 1000)}g`
    }
    
    // 数量为1时只显示单位，否则显示数量+单位
    return `${sellUnit}${sellUnitWay}`
  }

  get specSellUnit() {
    const { sellUnit, sellUnitWay } = this.data;
    // 如果没有销售单位规格，直接返回单位名称
    if (!sellUnit) {
      return sellUnitWay || ''
    }
    
    // 如果是千克单位且数量小于1，转换为克显示
    const isKilogram = sellUnitWay?.toLowerCase() === 'kg'
    if (sellUnit < 1 && isKilogram) {
      return `${Math.round(sellUnit * 1000)}g`
    }
    
    // 数量为1时只显示单位，否则显示数量+单位
    return `${Number(sellUnit) === 1 ? '' : sellUnit}${sellUnitWay}`
  }

  mounted () {
    this.sftpUrl = this.$store.state.user.sftpUrl
  }

  upShelves () {
    batchHandleGoods({
      storeId: this.companyId,
      goodsStatus: 1,
      supplierGoodsList: [{
        supplierGoodsId: this.data.supplierGoodsId,
        price: this.data.price || this.data.suggestedPrice,
        goodsId: this.data.goodsId
      }]
    }).then(() => {
      this.$toast('上架成功')
      this.$emit('reloadList')
    })
  }

  downShelves () {
    batchHandleGoods({
      storeId: this.companyId,
      goodsStatus: 2,
      supplierGoodsList: [{
        supplierGoodsId: this.data.supplierGoodsId,
        price: this.data.price || this.data.suggestedPrice,
        goodsId: this.data.goodsId
      }]
    }).then(() => {
      this.$toast('下架成功')
      this.$emit('reloadList')
    })
  }

  editPrice () {
    this.showPopup = true
    this.price = this.data.price || this.data.suggestedPrice
    this.scribingPrice = this.data.scribingPrice || undefined
    const init = this.data.initStockQuantity != null ? this.data.initStockQuantity : null
    const stock = this.data.stockQuantity != null ? this.data.stockQuantity : null
    if (init != null && stock != null) {
      this.soldQuantity = Math.max(0, Number(init) - Number(stock))
    } else {
      this.soldQuantity = 0
    }
    // 先定已售，再赋 init，watch 会按 剩余 = 库存 - 已售 同步 stockQuantity
    this.initStockQuantity = init
    this.stockQuantity = init != null
      ? Math.max(0, Number(init) - this.soldQuantity)
      : null
    this.limitPerPersonDaily = this.data.limitPerPersonDaily != null
      ? this.data.limitPerPersonDaily
      : null
    this.isDailyRefresh = this.data.isDailyRefresh != null
      ? this.data.isDailyRefresh
      : 1
  }

  normalizeOptionalPositiveInt (value: any): number | null | false {
    if (value === '' || value === null || value === undefined) {
      return null
    }
    const n = Number(value)
    if (!Number.isInteger(n) || n <= 0) {
      return false
    }
    return n
  }

  /** 可售数量：空=不限，允许 0 */
  normalizeOptionalNonNegativeInt (value: any): number | null | false {
    if (value === '' || value === null || value === undefined) {
      return null
    }
    const n = Number(value)
    if (!Number.isInteger(n) || n < 0) {
      return false
    }
    return n
  }

  validateStockAndLimit (): boolean {
    const stock = this.normalizeOptionalNonNegativeInt(this.initStockQuantity)
    if (stock === false) {
      this.$toast('可售数量/库存须为大于等于0的整数')
      return false
    }
    const limit = this.normalizeOptionalPositiveInt(this.limitPerPersonDaily)
    if (limit === false) {
      this.$toast('每人每日限购须为大于0的整数')
      return false
    }
    this.initStockQuantity = stock
    this.limitPerPersonDaily = limit
    return true
  }

  onChangePrice () {
    console.log('onChangePrice', this.price)
    return new Promise((resolve) => {
      if (!this.price || this.price < this.data.costPrice) {
        this.$toast('售价必须高于或等于进价！')
        resolve(false)
      }
      resolve(true)
    })
  }

  onChangeScribingPrice () {
    return new Promise((resolve) => {
      if (!this.scribingPrice) {
        this.scribingPrice = undefined
        resolve(true)
      } else if (this.scribingPrice <= this.price) {
        this.$toast('划线价必须高于售价！')
        resolve(false)
      }
      resolve(true)
    })
  }

  onCancel () {
    this.showPopup = false
  }

  async onSave () {
    const isCheckPrice = await this.onChangePrice()
    if (!isCheckPrice) return isCheckPrice
    const isCheckScribingPrice = await this.onChangeScribingPrice()
    if (!isCheckScribingPrice) return isCheckScribingPrice
    if (!this.validateStockAndLimit()) return false

    batchHandleGoods({
      storeId: this.companyId,
      goodsStatus: this.data.goodsStatus === 1 ? 1 : 2,
      supplierGoodsList: [{
        supplierGoodsId: this.data.supplierGoodsId,
        price: this.price,
        scribingPrice: this.scribingPrice,
        goodsId: this.data.goodsId,
        initStockQuantity: this.initStockQuantity,
        limitPerPersonDaily: this.limitPerPersonDaily,
        isDailyRefresh: this.isDailyRefresh
      }]
    }).then(() => {
      this.$toast('修改成功')
      this.data.price = this.price
      this.data.scribingPrice = this.scribingPrice
      this.data.initStockQuantity = this.initStockQuantity
      this.data.stockQuantity = this.initStockQuantity == null ? null : this.stockQuantity
      this.data.limitPerPersonDaily = this.limitPerPersonDaily
      this.data.isDailyRefresh = this.isDailyRefresh
      const { price, costPrice, sellUnit } = this.data
      this.data.profitMargin = this.calcMarginRate(price, costPrice, sellUnit)
      this.showPopup = false
      // this.$emit('reloadList')
    })
  }

  keep2(v: any) { return Math.round(v * 100) / 100 }

  /**
  * 通用毛利率计算 公式：(售价 - 进货价 * 规格值) / 售价 * 100
  */
  calcMarginRate(sellPrice: number | string, costPrice: number | string, specVal: number | string) {
    const price = Number(sellPrice)
    const cost = Number(costPrice)
    const spec = Number(specVal)
    if (!price || !cost || !spec) return ''
    const rate = (price - cost * spec) / price * 100
    return this.keep2(rate)
  }

  // 校验商品是否已失效/下架
  isGoodsValid() {
    const params = {
      shopId: this.data.storeId,
      goodsId: this.data.goodsId
    }
    return isGoodsValid(params)
      .then((res) => {
        if (res.data.isValid) {
          return true
        } else {
          this.$dialog
            .alert({
              message: '商品过期不存在'
            })
            .then(() => {
              this.$emit('reloadList')
            })
          return false
        }
      })
      .catch(() => {
        return false
      })
  }

  changeVal (val: number) {
    this.$emit('changeVal', val)
  }

  blurVal (packageIndex: number) {
    const packageId = this.data.goodsPackageList[packageIndex].packageId
    this.$emit('blurVal', packageId)
  }

  keyboardConfirm (price: string, packageIndex: number) {
    this.changeVal(Number(price))
    this.blurVal(packageIndex)
  }
}
